import React, { useState, useEffect, useRef } from "react";
import {
  useWindowDimensions,
} from "react-native";
import { LogoutUser } from "../redux/actions/auth";
import { connect, useSelector } from "react-redux";
import { useQueryClient } from "react-query";
import { Link } from "react-router-dom";
import { Button, IconButton, Menu, MenuItem, Stack, Avatar, Typography, Badge } from "@mui/material";
import { DarkModeOutlined, LightModeOutlined, LogoutSharp, KeyboardArrowDown, ShieldOutlined, DevicesOutlined, AdminPanelSettingsOutlined, ManageAccountsOutlined, GroupAddOutlined, AssessmentOutlined } from "@mui/icons-material";
import { useThemeMode } from "../theme/ThemeContext";
import { deviceStore } from "../mock/deviceStore";
import DeviceAccessPanel from "./DeviceAccessPanel";
import { WEBAUTHN_ENABLED } from "../features/webauthn";

const Header = (props) => {
  const [tabSelected, setTabSelected] = useState("home");
  const ref = useRef();
  const queryClient = useQueryClient();
  const { mode, toggleMode } = useThemeMode();

  useWindowDimensions();

  const { isAdmin, isSuperAdmin, analystName } = useSelector(
    (state) => ({
      isAdmin: state.auth.isAdmin,
      isSuperAdmin: state.auth.isSuperAdmin,
      analystName: state.auth.analystName,
    })
  );

  const [anchorEl, setAnchorEl] = useState();
  const [devicePanelOpen, setDevicePanelOpen] = useState(false);
  const [pendingCount, setPendingCount] = useState(() => deviceStore.pendingCount());

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref]);

  useEffect(() => {
    setTabSelected(props.tab);
  }, [props.tab]);

  const initials = analystName
    ? analystName.split(" ").map((n) => n[0]).join("").toUpperCase().slice(0, 2)
    : "?";

  return (
    <Stack
      sx={{
        width: "100%",
        backgroundColor: "var(--surface-1)",
        borderBottom: "1px solid var(--border-1)",
        px: { xs: 2, md: 3 },
        position: "sticky",
        top: 0,
        zIndex: 100,
      }}
    >
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        sx={{ height: 56 }}
      >
        <Stack direction="row" alignItems="center" spacing={1}>
          <Stack
            sx={{
              width: 28,
              height: 28,
              borderRadius: "6px",
              backgroundColor: "rgba(232, 108, 0, 1)",
              alignItems: "center",
              justifyContent: "center",
              p: "4px",
            }}
          >
            <img
              src="/stepout-icon.svg"
              alt="StepOut"
              style={{ width: "100%", height: "100%", objectFit: "contain" }}
            />
          </Stack>
          <Typography
            sx={{
              fontSize: "16px",
              fontWeight: 700,
              color: "var(--text-1)",
              letterSpacing: "-0.3px",
            }}
          >
            Analyst Portal
          </Typography>
        </Stack>

        <Stack direction="row" alignItems="center" spacing={0.5}>
          {/* Device Access Control */}
          {/* <IconButton
            aria-label="device access"
            onClick={() => {
              setPendingCount(deviceStore.pendingCount());
              setDevicePanelOpen(true);
            }}
            size="small"
            sx={{
              color: "var(--text-2)",
              borderRadius: "8px",
              width: 36,
              height: 36,
              "&:hover": { backgroundColor: "var(--surface-2)" },
            }}
          >
            <Badge
              badgeContent={pendingCount}
              color="error"
              sx={{ "& .MuiBadge-badge": { fontSize: "9px", minWidth: 14, height: 14, padding: "0 3px" } }}
            >
              <ShieldOutlined sx={{ fontSize: 20 }} />
            </Badge>
          </IconButton> */}

          {/* Theme toggle */}
          <IconButton
            aria-label="toggle theme"
            onClick={toggleMode}
            size="small"
            sx={{
              color: "var(--text-2)",
              borderRadius: "8px",
              width: 36,
              height: 36,
              "&:hover": {
                backgroundColor: "var(--surface-2)",
              },
            }}
          >
            {mode === "dark" ? (
              <LightModeOutlined sx={{ fontSize: 20 }} />
            ) : (
              <DarkModeOutlined sx={{ fontSize: 20 }} />
            )}
          </IconButton>

          <div>
            <Button
              onClick={handleMenu}
              sx={{
                gap: 0.5,
                px: 1,
                py: 0.5,
                borderRadius: "8px",
                textTransform: "none",
                color: "var(--text-1)",
                "&:hover": {
                  backgroundColor: "var(--surface-2)",
                },
              }}
              startIcon={
                <Avatar
                  sx={{
                    width: 24,
                    height: 24,
                    fontSize: "9px !important",
                    fontWeight: 700,
                    backgroundColor: "rgba(232, 108, 0, 0.15)",
                    color: "rgba(232, 108, 0, 1)",
                  }}
                >
                  {initials}
                </Avatar>
              }
              endIcon={<KeyboardArrowDown sx={{ fontSize: "18px !important", color: "var(--text-2)" }} />}
            >
              <Typography
                sx={{
                  fontSize: "13px",
                  fontWeight: 500,
                  display: { xs: "none", sm: "block" },
                }}
              >
                {analystName}
              </Typography>
            </Button>

            <Menu
              id="menu-appbar"
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleClose}
              anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
              transformOrigin={{ vertical: "top", horizontal: "right" }}
              slotProps={{
                paper: {
                  sx: {
                    borderRadius: "8px",
                    mt: 0.5,
                    minWidth: 160,
                    boxShadow: "var(--shadow-1)",
                    border: "1px solid var(--border-1)",
                    backgroundColor: "var(--surface-1)",
                  },
                },
              }}
            >
              {WEBAUTHN_ENABLED && (
                <MenuItem
                  component={Link}
                  to="/settings/devices"
                  onClick={handleClose}
                  sx={{ gap: 1, fontSize: "13px", color: "var(--text-1)", py: 1 }}
                >
                  <DevicesOutlined sx={{ fontSize: 18 }} />
                  My devices
                </MenuItem>
              )}
              {WEBAUTHN_ENABLED && isSuperAdmin && (
                <MenuItem
                  component={Link}
                  to="/admin/webauthn/requests"
                  onClick={handleClose}
                  sx={{ gap: 1, fontSize: "13px", color: "var(--text-1)", py: 1 }}
                >
                  <AdminPanelSettingsOutlined sx={{ fontSize: 18 }} />
                  Device approvals
                </MenuItem>
              )}
              {WEBAUTHN_ENABLED && isSuperAdmin && (
                <MenuItem
                  component={Link}
                  to="/admin/webauthn/credentials"
                  onClick={handleClose}
                  sx={{ gap: 1, fontSize: "13px", color: "var(--text-1)", py: 1 }}
                >
                  <ManageAccountsOutlined sx={{ fontSize: 18 }} />
                  Analyst credentials
                </MenuItem>
              )}
              {/* Duplicate-flow spec §11 — Admin and Privileged analysts. */}
              {(isAdmin || isSuperAdmin) && (
                <MenuItem
                  component={Link}
                  to="/admin/duplicate-players"
                  onClick={handleClose}
                  sx={{ gap: 1, fontSize: "13px", color: "var(--text-1)", py: 1 }}
                >
                  <GroupAddOutlined sx={{ fontSize: 18 }} />
                  Duplicate player requests
                </MenuItem>
              )}
              {/* Duplicate-flow spec §4 — read-only SAME_COUNTRY flags report. */}
              {(isAdmin || isSuperAdmin) && (
                <MenuItem
                  component={Link}
                  to="/admin/duplicate-flags"
                  onClick={handleClose}
                  sx={{ gap: 1, fontSize: "13px", color: "var(--text-1)", py: 1 }}
                >
                  <AssessmentOutlined sx={{ fontSize: 18 }} />
                  Same-country flags report
                </MenuItem>
              )}
              <MenuItem
                onClick={() => {
                  handleClose();
                  props.LogoutUser(queryClient);
                }}
                sx={{
                  gap: 1,
                  fontSize: "13px",
                  color: "#EF4444",
                  py: 1,
                }}
              >
                <LogoutSharp sx={{ fontSize: 18 }} />
                Logout
              </MenuItem>
            </Menu>
          </div>
        </Stack>
      </Stack>

      <DeviceAccessPanel
        open={devicePanelOpen}
        onClose={() => {
          setPendingCount(deviceStore.pendingCount());
          setDevicePanelOpen(false);
        }}
      />

      {/* Tabs */}
      <Stack
        direction="row"
        spacing={0}
        sx={{ mt: -0.5 }}
      >
        <Link
          to="/home"
          onClick={() => setTabSelected("home")}
          style={{
            textDecoration: "none",
            fontSize: "13px",
            fontWeight: 600,
            color:
              tabSelected === "home"
                ? "rgba(232, 108, 0, 1)"
                : "var(--text-2)",
            padding: "8px 16px",
            borderBottom: "2px solid",
            borderBottomColor:
              tabSelected === "home"
                ? "rgba(232, 108, 0, 1)"
                : "transparent",
            transition: "all 0.15s",
          }}
        >
          Home
        </Link>

        {isAdmin && (
          <Link
            to="/management"
            onClick={() => setTabSelected("management")}
            style={{
              textDecoration: "none",
              fontSize: "13px",
              fontWeight: 600,
              color:
                tabSelected === "management"
                  ? "rgba(232, 108, 0, 1)"
                  : "var(--text-2)",
              padding: "8px 16px",
              borderBottom: "2px solid",
              borderBottomColor:
                tabSelected === "management"
                  ? "rgba(232, 108, 0, 1)"
                  : "transparent",
              transition: "all 0.15s",
            }}
          >
            Match Management
          </Link>
        )}
      </Stack>
    </Stack>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    LogoutUser: () => {
      dispatch(LogoutUser());
    },
  };
};

export default connect("", mapDispatchToProps)(Header);
